import React, { useEffect, useContext } from 'react';
import './App.css';
import './assets/css/style.css';
import './assets/mycss/dloader.css';
import './assets/mycss/error.css';
import './assets/mycss/style.css';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-video.css';
import { TOKEN, url, base_url, BASE_URL } from './config';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/user/Login';
import Register from './components/user/registrationProcess/Register';
import Registration from './components/user/registrationProcess';
import store from './store';
import { loadUser  , logout} from './actions/userActions';
import ForgetPassword from './components/user/ForgetPassword';
import ProtectedRoute from './components/route/ProtectedRoute';
import SupplierProtectedRoute from './components/route/SupplierProtectedRoute';
import PlanProtectedRoute from './components/route/PlanProtectedRoute';
import PlanDetailRoute from './components/route/PlanDetailRoute';
import AddProduct from './components/addProducts';
import ContactUs from './components/user/myAccount/ContactUs';
import ChatPrivacySettings from './components/user/myAccount/ChatPrivacySettings';
import Profile from './components/user/myAccount/Profile';
import ChangePassword from './components/user/myAccount/ChangePassword';
import PaymentInfo from './components/user/myAccount/PaymentInfo';
import NewPayment from './components/user/myAccount/NewPayment';
import PlanDetails from './components/user/myAccount/PlanDetails';
import CardManagement from './components/user/myAccount/CardManagement';
import ProductRoute from './components/route/ProductRoute';
import MyProducts from './components/user/myProducts';
import Favorites from './components/user/favorites';
import AddSingleProduct from './components/addProducts/addSingleProduct';
import Privacy from './components/HomePage/Privacy';
import TermCondition from './components/HomePage/Term&Condition';
import Chat from './components/user/chat';
import QRcode from './components/product/QRcode';
import IyzipayComponent from './components/product/Iyzipay';
import DetailsPage from './components/detailsProducts';
import RatingDetails from './components/ratingDetails';
import { Context } from "./components/Wrapper";
import Lens from './components/product/Lens';
import OwlCrousel from './components/product/OwlCrousel';
import Otp from './components/user/myAccount/Otp';
import EditSingleProduct from './components/editSingleProduct';
import EditProduct from './components/editProducts';
import Advertisement from './components/advertisement';
import AdvertisementPlanDetails from './components/advertisePlanDetail';
import AdvertisedProducts from './components/advertisedProducts';
import EmptyPage from './components/layout/404';
import mixpanel from 'mixpanel-browser';
import moment from 'moment';
import Confirmation from './components/user/registrationProcess/Confirmation';
import StripeForm from './components/stripe/StripeForm';
import AddColorStones from './components/addProducts/addSingleProduct/AddColorStones';

import NewHome from './components/newHome/NewHome';
import Brevo_frame from './components/brevoFrame/Brevo_frame';


import { useDispatch } from 'react-redux';
import ElectronicMessage from './components/HomePage/ElectronicMessage';
import CookieConsentApp from './components/layout/CookiePage';
import DeviceList from './components/user/DeviceList';
import NewBillingInformation from './components/user/NewBillingInformation';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
mixpanel.init('b00914fe4bd3518056747df88e6af79a', {
  debug: true
});



function App() {
  const dispatch = useDispatch()
  const context = useContext(Context);
  const history = useHistory()

  useEffect(() => {
    if (TOKEN && window.location.pathname  != "/login" && window.location.pathname  != "/payment-success") {
      dispatch(loadUser())
    }
  })


  var uuid = localStorage.getItem("uuid");
  var lang = localStorage.getItem("lang");
  var country = localStorage.getItem("country");
  if (lang == null) {
    localStorage.setItem("lang", 'tr');
  }
  if (country === null) {
    localStorage.setItem("country", 'turkey');
  }

  const date = moment.utc().format();
  const local = moment.utc(date).local().format();

      const handleLogout = () => {
          dispatch(logout());
          localStorage.removeItem('isAuthenticated');
          localStorage.removeItem('address');
          localStorage.removeItem('user_data');
          localStorage.removeItem('is_authenticated_false');
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('socket_group_id')
          sessionStorage.removeItem('loading')
          alert.success('Logout successful')
          window.location.href = url;
      }
  

  useEffect(() => {
    if (localStorage.getItem("user_data") && localStorage.getItem("new_uuid") && !localStorage.getItem("is_authenticated_false")) {
      localStorage.setItem("is_authenticated_uuid",1)
      axios.post(`${BASE_URL}/update-device-token`, {
        device_type: 'Web',
        device_token: localStorage.getItem("uuid"),
        new_device_token: localStorage.getItem("new_uuid")
      },{
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('isAuthenticated'),
          'lang': localStorage.getItem('lang'),
        }
      }
    ).then((res) => {
        if (res.status == 200) {
          if (res?.data.data?.badge == 1) {
            handleLogout();
          }
          const migrated = localStorage.getItem("new_uuid");
          if (migrated && migrated !== "null" && migrated !== "undefined") {
            localStorage.setItem("uuid", migrated);
          }
          localStorage.removeItem("new_uuid");
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },[])

  return (
    <div className="App">
      <Router>
        <Switch>
          {/* <Route exact path={url + "/purchase-subscription-plan"} component={IyzipayComponent} /> */}
          {/* <Route exact path={url + "/purchase-subscription-plan"} component={StripeForm} /> */}

          <Route exact path={url + "/payment-success"} component={Confirmation} />

          <Route exact path={url + "/"} component={Home} />
          <Route exact path={url + "/home"} component={Home} />
          <Route exact path={url + "/brevo-frame"} component={Brevo_frame} />
          <Route exact path={url + "/device-list/:slug"} component={DeviceList} />
          <Route exact path={url + "/new-business-info"} component={NewBillingInformation} />

          {/* <Redirect from="/home" to="/" /> */}
          
          <Route exact path={url + "/login"} component={Login} />
          <Route exact path={url + "/register"} component={Register} />
          <Route exact path={url + "/forget-password"} component={ForgetPassword} />
          <ProtectedRoute exact path={url + "/profile"} component={Profile} />
          <ProtectedRoute exact path={url + "/change-password"} component={ChangePassword} />
          <ProtectedRoute exact path={url + "/payment-history"} component={PaymentInfo} />
          <ProtectedRoute exact path={url + "/new-payment"} component={NewPayment} />
          <ProtectedRoute exact path={url + "/contact-us"} component={ContactUs} />
          <ProtectedRoute exact path={url + "/chat-privacy"} component={ChatPrivacySettings} />
          <ProtectedRoute exact path={url + "/category/:slug"} component={ProductRoute} />
          <SupplierProtectedRoute exact path={url + "/add-product"} component={AddProduct} />
          <Route exact path={url + "/business-info"} component={Registration} />
          <PlanDetailRoute exact path={url + "/plan-details"} component={PlanDetails} />
          <PlanDetailRoute exact path={url + "/card-management"} component={CardManagement} />
          <SupplierProtectedRoute exact path={url + "/myproducts/:slug"} component={MyProducts} />
          <ProtectedRoute exact path={url + "/favorites/:slug"} component={Favorites} />
          <PlanProtectedRoute exact path={url + "/add-single-product"} component={AddSingleProduct} />
          <ProtectedRoute exact path={url + "/message"} component={Chat} />
          <PlanProtectedRoute exact path={url + "/details/:category/:id"} component={DetailsPage} />
          <PlanProtectedRoute exact path={url + "/rating-details/:id"} component={RatingDetails} />
          <ProtectedRoute exact path={url + "/otp"} component={Otp} />
          <ProtectedRoute exact path={url + "/edit-product/:id"} component={EditSingleProduct} />
          <ProtectedRoute exact path={url + "/edit-full-product/:slug/:id"} component={EditProduct} />
          <ProtectedRoute exact path={url + "/edit-color-stones/:id"} component={AddColorStones} />
          <ProtectedRoute exact path={url + "/advertisement/:slug"} component={Advertisement} />
          <ProtectedRoute exact path={url + "/advertise-plan-details/:slug"} component={AdvertisementPlanDetails} />
          <ProtectedRoute exact path={url + "/advertised-products"} component={AdvertisedProducts} />

          <Route exact path={url + '/new-home'} component={NewHome} />

          <Route exact path={url + "/privacy"} component={Privacy} />
          <Route exact path={url + "/terms&conditions"} component={TermCondition} />
          <Route exact path={url + "/electronic-message"} component={ElectronicMessage} />
          <Route exact path={url + '/qrcode'} component={QRcode} />
          <Route exact path={url + '/lens'} component={Lens} />
          <Route exact path={url + '/owl-crousel'} component={OwlCrousel} />


          {/* <Route path={url + '/404'} component={EmptyPage} /> */}
          <Route path='*' exact={true} component={EmptyPage} />
          {/* <Route component={EmptyPage} /> */}
          {/* <Redirect from='*' to={url + '/404'} /> */}
        </Switch>
      </Router>

      <CookieConsentApp/>
    </div>
  );
}

export default App;
